<template>
    <div ref="index_template" class="x_scrollable">
        <!-- Messages -->
        <ErrorMessages :errors="errors" :description="$t('ui.general.error')" :is_closable="true"></ErrorMessages>
        <!-- Buttons -->
        <div refs="header_buttons">
            <div v-for="header_button in header_buttons" :is="header_button.is" :to="header_button.to" :class="header_button.class" @click.prevent="header_button.click">
                <span v-html="header_button.content"></span>
            </div>
        </div>
        <!-- Data table -->
        <table class="ui celled table">
            <thead class="center aligned">
                <!-- Column names -->
                <tr>
                    <th v-for="column in columns">{{ column.filter.human_name }}</th>
                    <th>
                        <div class="ui basic black icon button" @click.prevent="toggle_filter">
                            <i class="double up angle icon" v-if="show_filter"></i>
                            <i class="double down angle icon" v-else></i>
                        </div>
                    </th>
                </tr>
                <!-- Filter -->
                <tr v-show="show_filter">
                    <th v-for="column in columns">
                        <div class="ui mini input" v-if="column.filter.type == 'text'">
                          <input type="text" v-model="search_params[column.filter.attribute_name]" @keyup.enter="fetch_index_items">
                        </div>
                        <div class="ui mini input" v-if="column.filter.type == 'number'">
                          <input type="number" v-model="search_params[column.filter.attribute_name]" @keyup.enter="fetch_index_items">
                        </div>
                        <table v-if="column.filter.type == 'number_range'">
                            <tbody>
                                <tr>
                                    <td>
                                        從
                                        <div class="ui input">
                                            <input type="number" v-model="search_params[column.filter.attribute_name_of_from]" @keypress.enter="fetch_index_items">
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        到
                                        <div class="ui input">
                                            <input type="number" v-model="search_params[column.filter.attribute_name_of_to]" @keypress.enter="fetch_index_items">
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="ui mini input" v-if="column.filter.type == 'checkbox'">
                            <div class="ui checkbox">
                                <input type="checkbox" v-model="search_params[column.filter.attribute_name]">
                                <label>{{ column.filter.human_name }}</label>
                            </div>
                        </div>
                        <div class="ui mini input" v-if="column.filter.type == 'datetime'">
                            <input type="datetime-local" v-model="search_params[column.filter.attribute_name]">
                        </div>
                        <table v-if="column.filter.type == 'datetime_range'">
                            <tbody>
                                <tr>
                                    <td>從</td>
                                    <td>
                                        <div class="ui mini input">
                                            <input type="datetime-local" v-model="search_params[column.filter.attribute_name_of_from]">
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>到</td>
                                    <td>
                                        <div class="ui mini input">
                                            <input type="datetime-local" v-model="search_params[column.filter.attribute_name_of_to]">
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </th>
                    <th>
                        <div class="ui buttons">
                            <div class="ui basic black icon button" @click.prevent="fetch_index_items">
                                <i class="search icon"></i>
                            </div>
                            <div class="ui basic black icon button" @click.prevent="init_search_params">
                                <i class="refresh icon"></i>
                            </div>
                        </div>
                    </th>
                </tr>
            </thead>
            <!-- Data loader -->
            <tbody v-if="is_loading" class="center aligned">
                <tr class="loading">
                    <td :colspan="columns.length + 1">
                        <div class="ui active centered inline loader"></div>
                    </td>
                </tr>
            </tbody>
            <!-- Data contents -->
            <tbody v-else class="center aligned">
                <Item
                    v-for="index_item in index_items"
                    :key="index_item.identity"
                    :index_item="index_item"
                    :columns="columns"
                    :edit_index_item_url="edit_index_item_url"
                    :delete_index_item_url="delete_index_item_url"
                    :update_index_item_url="update_index_item_url"
                    :authentication_token="authentication_token"
                    :index_item_name="index_item_name"
                    :api_response_corresponding_name_of_index_item="api_response_corresponding_name_of_index_item"
                    :blank_value_text="blank_value_text"
                    >
                </Item>
                <tr v-if="index_items.length <= 0" class="center aligned">
                    <td :colspan="columns.length + 1">
                        <h5>{{ $t('ui.general.no_data') }}</h5>
                    </td>
                </tr>
            </tbody>
        </table>
        <!-- Paginator -->
        <div
            is="Paginator"
            :total_pages="pagination.total_pages"
            :current_page="pagination.current_page"
            :change_page_channel="paginator_channel_name"
            :disabled="is_loading"
            v-if="pagination.total_pages || pagination.current_page"
            >
        </div>
    </div>
</template>

<script>
import Item from "./index_item.vue"
import Paginator from '@toolbox/pagination/paginator.vue'
import ErrorMessages from '@toolbox/error_box/main.vue'
export default {
    name: "CRUDTemplatesIndex",
    props: {
        // table欄位及filter表現方式
        columns: {
            type: Array,
            default: () => { return [
                // {
                //     filter: {
                //         type: "text",
                //         human_name: "名稱",
                //         attribute_name: "name",
                //     },
                //     item: {
                //         type: "text",
                //         attribute_name: "name",
                //     }
                // }
            ]},
        },
        // header位置要顯示的buttons
        header_buttons: {
            type: Array,
            default: () => { return [
                // {
                //     is: "router-link" or "button",
                //     class: "ui basic positive button",
                //     content: "<i class='plus icon'></i>建立新客戶",
                //     to: {name: 'new_customer'},
                //     click: "method_name",
                // },
            ]},
        },
        // provider, customer...
        module_scope: String,
        // 引用本元件頁面在layout中註冊的module name
        module_name: String,
        // 分頁用頻道名
        paginator_channel_name: String,
        // url object範例:
        // {
        //     type: "vue" or "http",
        //     url: url_string or vue_router_name,
        //     params: [
        //         {
        //             key_name: 參數key值,
        //             attribute_name: 參數要取用哪個attribute,
        //             source: "index_item" or "route_params"
        //         },
        //         ...
        //     ]
        // }
        // 抓取資料url
        fetch_index_items_url: {
            type: Object,
            default: () => { return {} },
        },
        // 編輯頁連結url
        edit_index_item_url: {
            type: Object
        },
        // 刪除對象url
        delete_index_item_url: {
            type: Object
        },
        // 更新對象url
        update_index_item_url: {
            type: Object
        },
        // auth
        authentication_token: String,
        // 對象的human name
        index_item_name: String,
        // response中代表群集對象的keyname
        api_response_corresponding_name_of_index_items: String,
        // response中代表單體對象的keyname
        api_response_corresponding_name_of_index_item: String,
        // 空白欄位預設文字
        blank_value_text: {
            type: String,
            default: () => { return "" },
        },
    },
    data() {
        return {
            is_initialized: false,
            is_loading: false,
            is_search_params_changed: false,
            index_items: [],
            errors: [],
        }
    },
    computed: {
        pagination() {
            return this.$store.state[this.module_scope][this.module_name].pagination
        },
        search_params() {
            return this.$store.state[this.module_scope][this.module_name].search_params
        },
        show_filter() {
            return this.$store.state[this.module_scope][this.module_name].show_filter
        }
    },
    created() {
    },
    mounted() {
        this.init()
    },
    watch: {
        search_params: {
            handler(val, oldVal) {
                this.is_search_params_changed = true
            },
            deep: true
        },
    },
    methods: {
        async init() {
            try {
                await new Promise(resolve => {
                    this.is_initialized = false
                    resolve()
                })
                await this.$store.commit(this.module_scope + '/' + this.module_name + '/init_search_params')
                await this.fetch_index_items()
                await new Promise(resolve => {
                    this.is_initialized = true
                    resolve()
                })
            } catch (e) {
                switch (e) {
                    default:
                    console.log("init error: ")
                    console.log(e)
                }
            } finally {
                // pagination channel
                this.$bus.$off(this.paginator_channel_name)
                this.$bus.$on(this.paginator_channel_name, (page) => {
                    this.$store.commit(this.module_scope + '/' + this.module_name + '/set_current_page', page)
                    this.fetch_index_items()
                })
            }
        },
        fetch_index_items() {
            if (this.is_loading == false) {
                this.errors = []
                this.is_loading = true
                if (this.is_search_params_changed) {
                    this.$store.commit(this.module_scope + '/' + this.module_name + '/set_current_page', null)
                    this.is_search_params_changed = false
                }
                var url = this.convert_url_object(this.fetch_index_items_url) + "?" + object_to_query(this.search_params) + "&" + object_to_query({page: this.pagination.current_page})
                return axios.get(url, { headers: { Authorization: this.authentication_token }})
                    .then(response => {
                        if (response.data.status == "success") {
                            this.index_items = response.data[this.api_response_corresponding_name_of_index_items]
                            if (response.data.pagination) {
                                this.$store.commit(this.module_scope + '/' + this.module_name + '/set_current_page', response.data.pagination.current_page)
                                this.$store.commit(this.module_scope + '/' + this.module_name + '/set_total_pages', response.data.pagination.total_pages)
                            }
                        } else {
                            return Promise.reject(response.data)
                        }
                    })
                    .catch(error => {
                        if (error.response) {
                            switch (error.response.status) {
                                default:
                                this.errors.push(error.response.status + ' ' + error.response.statusText)
                            }
                            this.$noty.error('取得 ' + this.index_item_name + ' 失敗: ' + error.response.status + ' ' + error.response.statusText)
                        } else if (error.errors) {
                            this.$noty.error('取得 ' + this.index_item_name + ' 失敗: ' + error.errors)
                            this.errors = response.data.errors
                        } else {
                            this.errors.push(this.$t('ui.general.server_offline'))
                            this.$noty.error(this.$t('ui.general.server_offline'))
                        }
                        return Promise.reject(error)
                    })
                    .finally(() => {
                        setTimeout(() => {
                            this.is_loading = false
                        }, 300)
                    })
            }
        },
        init_search_params() {
            this.$store.commit(this.module_scope + '/' + this.module_name + '/init_search_params')
            $(this.$refs.index_template).find(".ui.dropdown").dropdown('clear')
        },
        toggle_filter() {
            this.$store.commit(this.module_scope + '/' + this.module_name + '/toggle_filter')
        },
        convert_url_object(obj) {
            var params_obj = {}
            for (let param of obj.params) {
                switch (param.source) {
                    case "index_item":
                        params_obj[param.key_name] = this.index_item[param.attribute_name]
                        break
                    case "route_params":
                        params_obj[param.key_name] = this.$route.params[param.attribute_name]
                        break
                }
            }
            switch (obj.type) {
                case "vue":
                    return {
                        name: obj.url,
                        params: params_obj,
                    }
                    break
                case "http":
                    return new RestUrl(obj.url).parse(params_obj)
                    break
            }
        },
    },
    components: {
        Item,
        Paginator,
        ErrorMessages,
    }
}
</script>

<style scoped>
#index_template {
    overflow-x: auto;
}
</style>
